import React, { useContext } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { NavContext } from '../context/NavProvider';
import LayoutMain from '../components/layouts/LayoutMain';
import Sidebar from '../components/Sidebar';
import Title from '../components/elements/Title';
import ContactForm from '../components/ContactForm';
import Vimeo from '@u-wave/react-vimeo';
import { Seo } from '../components/Seo';
import { ConfiguratorContext } from '../context/ConfiguratorProvider';

import {
  wrapAbove,
  wrapAboveContentWrap,
  topCard,
  topCardContent,
  wrapBelowAlt,
} from '../templates/packagesPage.module.scss';
import { aboutUs } from '../components/elements/input.module.scss';
import * as aboutStyles from './aboutUs.module.scss';

const AboutUsPageTemplate = ({ pageContext }) => {
  // console.log('ABOUT US PAGE CONTEXT', pageContext);

  const faqDataQuery = useStaticQuery(graphql`
    query faqQuery {
      allWpFaq {
        edges {
          node {
            menuOrder
            date
            title
            content
          }
        }
      }
    }
  `);

  const { title, content } = pageContext;
  const { isMobile } = useContext(ConfiguratorContext);

  const faqData = faqDataQuery.allWpFaq.edges;

  // sort faqData by date and menuOrder
  // faqData.sort((a, b) => new Date(a.node.date) - new Date(b.node.date));
  faqData.sort((a, b) => a.node.menuOrder - b.node.menuOrder);
  // faqData.sort((a, b) => {
  //   const dateComparison = new Date(a.node.date) - new Date(b.node.date);
  //   if (dateComparison !== 0) {
  //     return dateComparison;
  //   }
  //   return a.node.menuOrder - b.node.menuOrder;
  // });

  // console.log('FAQ DATA', faqData);

  const handleCardClick = (card) => {
    // console.log('CARD', card.target.parentElement);
    if (card.target.nextElementSibling) {
      card.target.parentElement.classList.toggle(aboutStyles.active);
      card.target.nextElementSibling.classList.toggle(aboutStyles.visible);
    } else {
      return false;
    }
  };

  return (
    <LayoutMain>
      <div className={wrapAbove}>
        <NavContext.Consumer>
          {(context) => (
            <Sidebar
              addAltClass={false}
              isHomePage={false}
              isActive={context.isActive}
              setIsActive={() => context.setIsActive()}
              isToggleStyle={context.isToggleStyle}
              setToggleStyle={() => context.setToggleStyle()}
              toggleActive={() => context.toggleActive()}
              onClickOutside={() => {
                context.setIsActive(false);
                context.setToggleStyle(false);
              }}
            />
          )}
        </NavContext.Consumer>
        <div className={wrapAboveContentWrap}>
          <div className={topCard}>
            <Title text={title} size="2" />
            <div className={topCardContent}>
              <div dangerouslySetInnerHTML={{ __html: content }}></div>
            </div>
          </div>
        </div>
      </div>
      <div className={wrapBelowAlt}>
        <section className="section-alt">
          <div className="container-alt container-homepage">
            <div className={aboutStyles.aboutUsVideo}>
              <Vimeo
                video="823739752"
                width="620"
                height="450"
                responsive={true}
                // onLoaded={() => handleVideoLoaded()}
                // onError={(err) => handleVideoError(err)}
              />
            </div>
            <div className={aboutStyles.aboutUsFaq}>
              <Title
                className={aboutStyles.contactCardTitle}
                text="FAQ"
                size="2"
              />
              {faqData.map((faq, index) => {
                return (
                  <div className={aboutStyles.aboutUsFaqCard} key={index}>
                    <h3
                      className={aboutStyles.aboutUsFaqCardTitle}
                      onClick={(e) => handleCardClick(e)}
                    >
                      {faq.node.title}
                    </h3>
                    <div
                      className={aboutStyles.aboutUsFaqCardContent}
                      dangerouslySetInnerHTML={{ __html: faq.node.content }}
                    ></div>
                  </div>
                );
              })}
            </div>
            <div className={aboutStyles.aboutUsContact}>
              <div className={aboutStyles.contactCard}>
                <Title
                  className={aboutStyles.contactCardTitle}
                  text="Drop us a line"
                  size="2"
                />
                <div className={aboutStyles.contactCardContent}>
                  <p>
                    We have packages to fit every need and every budget! Please
                    let us know what you are looking for so we can make it
                    happen!
                  </p>
                  <p className={aboutStyles.contactCardNumber}>718.971.9710</p>
                  <a
                    className={aboutStyles.contactCardEmail}
                    href="mailto:info@leimageinc.com"
                    data-link-type="contactLink"
                    data-link-page-type="CONTACT"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="info@leimageinc.com (Opens in a new window)"
                  >
                    info@leimageinc.com
                  </a>
                  <div className={aboutStyles.contactCardAddress}>
                    <p>254 36th Street</p>
                    <p>Suite B-432</p>
                    <p>Brooklyn NY 11232</p>
                  </div>
                </div>
              </div>
              <div className={aboutStyles.contactForm}>
                <ContactForm
                  isPage={true}
                  id={'ask-us-anything'}
                  customClass={aboutUs}
                  isMobile={isMobile}
                />
              </div>
            </div>
          </div>
        </section>
      </div>
    </LayoutMain>
  );
};
export default AboutUsPageTemplate;

export const Head = ({ pageContext }) => {
  const seo = pageContext.seo;
  const featuredImage =
    pageContext.featuredImage?.node?.localFile?.publicURL || '';

  return (
    <Seo
      bodyClass={pageContext.customBodyClass}
      title={seo.title}
      description={seo.metaDesc}
      rootUri={pageContext.rootUri}
      featuredImage={featuredImage}
      schema={seo.schema ? JSON.parse(seo.schema.raw) : null}
    />
  );
};
